import React from "react";
import { ProfileMenu } from "msp-ui-components";
import { MessageContext, withMultiLanguagesConsumer } from "../../contexts/messages";
import { makeStyles } from '@material-ui/core/styles';
const Profile = withMultiLanguagesConsumer((props) => {
    const {
        locale,
        setLocale,
        firstname,
        lastname,
        domain,
        token,
        hiddenList
    } = props;
    
    const langList = [
        {name: "English", code: "en-US"},
        {name: "简体中文", code: "zh-CN"},
        {name: "繁体中文", code: "zh-HK"}
    ];
    let selectedLanguage = langList.find(lan => lan.code == locale) ? langList.find(lan => lan.code == locale).name : null;
    return (
        <ProfileMenu 
            firstname={firstname ? firstname : ""} 
            lastname={lastname ? lastname : ""}
            languages={langList}
            selectedLanguage={selectedLanguage}
            onChangeLanguage={(lan) => setLocale(lan.code)}
            serverUrl={process.env.REACT_APP_ENV == "development" ? "https://cloud.menusifudev.com" : null}
            hiddenList={hiddenList}
            domain={domain}
            token={token}
        />
    );
});

const useStyles = makeStyles({
    profile: {
      position: "absolute",
      right: 30,
      top: 30
    },
});

export const withProfile = (WrappedComponent,hiddenList) => {
    const ProfileIcon = () => {
        const classes = useStyles();
        return (
            <div className={classes.profile}>
                <Profile hiddenList={hiddenList} />
            </div>
        )
    }
    return withMultiLanguagesConsumer((props) => (
        <div>
            <ProfileIcon />
            <WrappedComponent {...props}/>
        </div>
    ))
}

export default Profile;